import { createFormDataRequest } from "@/helpers/FormHelpers";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Note, { NoteForm } from "@/interfaces/Note";
import api from "../api";

export const userNotesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserNotes: build.query<IPaginateResponse<Note>, [string, IFilters]>({
      query: ([id, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/users/${id}/notes`,
          params,
        };
      },
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "UserNotes" as const,
                id,
              })),
              { type: "UserNotes", id: "LIST" },
            ]
          : [],
    }),
    storeUserNote: build.mutation<Note, [string, NoteForm]>({
      query: ([id, body]) => ({
        url: `/users/${id}/notes`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, [userId]) => [
        { type: "UserNotes", userId },
      ],
    }),
    deleteUserNote: build.mutation<void, [string, string]>({
      query: ([userId, noteId]) => ({
        url: `/users/${userId}/notes/${noteId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [userId]) => [
        { type: "UserNotes", userId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetUserNotesQuery,
  useStoreUserNoteMutation,
  useDeleteUserNoteMutation,
} = userNotesApi;
